import { useMutation } from '@tanstack/react-query';

import { coreActionsAxiosClient } from '@/lib';
import { Nullable, Timestamp } from '@/types';
import { withLogger } from '@/utils';

import { meetingMutation } from '../data/mutation-keys';
import { MeetingTemplateForm } from '../hooks/use-meeting-template-form';

export type Payload = {
  formData: MeetingTemplateForm;
};

type Param = {
  id?: Nullable<string>;
  meeting_name?: string;
  category?: string;
  status?: 'User' | 'Modified';
  original_template_id?: string;
  agenda?:
    | Array<{
        itemNo: string;
        topic: string;
        discussion_points: Array<{
          name: string;
        }>;
      }>
    | Nullable<string>;
};

type Response = {
  success: boolean;
  data: {
    id: string;
    meeting_name: string;
    category: string;
    status: 'User' | 'Modified';
    original_template_id: string;
    company_id: string;
    user_id: string;
    agenda: Array<{
      itemNo: string;
      topic: string;
      discussion_points: Array<{
        name: string;
      }>;
    }> | null;
    created_at: Nullable<Timestamp>;
    updated_at: Nullable<Timestamp>;
    deleted_at: Nullable<Timestamp>;
  };
  message: string;
};

type Return = Response['data'];

export type MeetingTemplateData = {
  param: Param;
  response: Response;
  return: Return;
};

export const mutateMeetingTemplate = withLogger(
  async (param: Param): Promise<Return> => {
    const response = await coreActionsAxiosClient.post<Response>(
      '/template/store',
      param,
    );
    return response.data.data;
  },
);

export const useMutateMeetingTemplate = () => {
  const mutation = useMutation({
    mutationKey: meetingMutation.mutate,
    mutationFn: mutateMeetingTemplate,
  });

  return mutation;
};
